export enum CollectDataFormItemType {
  TextBlock = 'textBlock',
  TextInput = 'textInput',
  Date = 'date',
  Number = 'number',
  Select = 'select',
  Radio = 'radio',
  Checkbox = 'checkbox',
  Video = 'video',
  File = 'file',
}

export enum CollectDataConfigStatus {
  Created = 'created',
  Completed = 'completed',
  WaitingForApproval = 'waiting_for_approval',
  Failed = 'failed',
  PartiallyCompleted = 'partially_completed', // This status used only when there are some delayed steps
}

export enum CollectDataStepType {
  DriverLicense = 'driver_license',
  VehicleInsurance = 'vehicle_and_insurance',
  EIN = 'business_entity',
  InsuranceDeclaration = 'insurance_amount_declaration',
  VehicleRegistration = 'vehicle_registration',
  Vaccination = 'vaccination_information',
  BGC = 'background_check',
  InsuranceBeneficiary = 'insurance_beneficiary',
  SignContract = 'sign_contract',
  StitchPayment = 'stitch_payment',
  MVR = 'mvr_upload',
  Form = 'form',
  InsuranceCoverage = 'insurance',
  LMSTraining = 'lms_training',
  MCNumber = 'mc_number',
  DOTNumber = 'dot_number',
  PaymentMethod = 'payment_method',
  PIICollection = 'ssn_and_address',
}

export enum CollectDataStepStatus {
  Created = 'created',
  InProgress = 'in_progress',
  WaitingForInternalApproval = 'waiting_for_internal_approval',
  WaitingForApproval = 'waiting_for_approval',
  Completed = 'completed',
  Failed = 'failed', // Applies only for BG check
  Archived = 'archived',
}
